export default __webpack_public_path__ + "static/24242-4b54bfae9ecb42988431a7f1932e89d5.jpg";